/* eslint-disable no-magic-numbers */
import { fontFamily, resolutionFullHD } from './constants';
import { getRel, getRelX, getRelY } from './utils/getRel';
import { scaleToCover, scaleToFit } from './utils/scaleTo';

export function TeamBanner(team, resources) {
	const container = new PIXI.Container();
	container.anchor = new PIXI.Point(0.5, 0);
	container.position = getRel(1, 0.1);
	const bannerWidth = getRelX(0.2);

	// banner
	const banner = new PIXI.Sprite(resources.banner.texture);
	banner.anchor = new PIXI.Point(0.5, 0);
	scaleToFit(banner, bannerWidth, getRelY(0.8));
	container.addChild(banner);

	// avatar
	const avatarSize = banner.width * 0.5;
	const avatarCont = new PIXI.Container();
	const avatar = new PIXI.Sprite(resources[ team.avatar ].texture);
	const avatarMask = new PIXI.Graphics();
	avatarMask.beginFill(0x00FF00, 1);
	avatarMask.drawCircle(0, 0, avatarSize / 2);
	avatarCont.anchor = new PIXI.Point(0, 0);
	avatarMask.anchor = new PIXI.Point(0.5, 0.5);
	avatar.anchor = new PIXI.Point(0.5, 0.5);
	scaleToCover(avatar, avatarSize, avatarSize);
	avatarCont.addChild(avatar);
	avatarCont.addChild(avatarMask);
	avatarCont.mask = avatarMask;
	avatarCont.position = new PIXI.Point(0, avatarSize * 0.1);
	container.addChild(avatarCont);

	// name
	const relFontSize = 34 * (window.rendererWidth / resolutionFullHD);
	const name = new PIXI.Text(team.name, {
		fontWeight: 'bold',
		fontSize: relFontSize + 'px',
		fontFamily: fontFamily,
		fill: '#FFFFFF',
		align: 'center',
		wordWrap: true,
		wordWrapWidth: bannerWidth * 0.9,
	});
	name.anchor = new PIXI.Point(0.5, 0);
	name.position = new PIXI.Point(0, avatarSize * 0.65);
	container.addChild(name);

	// members
	let member;
	const memberAvatarSize = avatarSize * 0.3;
	for (let i = 0; i < team.members.length; i++) {
		if (i > 6) {
			const dotdotdot = new PIXI.Text('...', {
				fontWeight: 'normal',
				fontSize: (relFontSize * 0.6) + 'px',
				fontFamily: fontFamily,
				fill: '#FFFFFF',
				align: 'left',
			});
			dotdotdot.position.x = -dotdotdot.width / 2;
			dotdotdot.position.y = (avatarSize * 1.2) + (i * memberAvatarSize * 1.2) - (memberAvatarSize * 0.6);
			container.addChild(dotdotdot);
			break;
		} else {
			member = TeamMember(team.members[ i ], memberAvatarSize, resources);
			member.position.x = -(avatarSize * 0.6);
			member.position.y = (avatarSize * 1.2) + (i * memberAvatarSize * 1.2);
			container.addChild(member);
		}
	}
	return container;
}

export function TeamMember(member, avatarSize, resources, bannerWidth) {
	avatarSize = avatarSize ? avatarSize : getRelX(0.1);
	bannerWidth = bannerWidth ? bannerWidth : getRelX(0.2);
	const cont = new PIXI.Container();
	const avatarCont = new PIXI.Container();
	const avatar = new PIXI.Sprite(resources[ member.avatar ].texture);
	const avatarMask = new PIXI.Graphics();
	avatarMask.beginFill(0x00FF00, 1);
	avatarMask.drawCircle(0, 0, avatarSize / 2);
	cont.anchor = new PIXI.Point(0, 0);
	avatarCont.anchor = new PIXI.Point(0.5, 0.5);
	avatarMask.anchor = new PIXI.Point(0.5, 0.5);
	avatar.anchor = new PIXI.Point(0.5, 0.5);
	scaleToCover(avatar, avatarSize, avatarSize);
	const relFontSize = 20 * (window.rendererWidth / resolutionFullHD);
	const text = new PIXI.Text(member.name, {
		fontWeight: 'normal',
		fontSize: relFontSize + 'px',
		fontFamily: fontFamily,
		fill: '#FFFFFF',
		align: 'left',
		wordWrap: true,
		wordWrapWidth: bannerWidth - avatarSize,
	});
	text.anchor = new PIXI.Point(0, 0.5);
	text.position = new PIXI.Point(avatarSize * 0.7, 0);
	avatarCont.addChild(avatar);
	avatarCont.addChild(avatarMask);
	avatarCont.mask = avatarMask;
	cont.addChild(avatarCont);
	cont.addChild(text);

	return cont;
}
